import { graphql } from "./generated/gql";

export const StakeholderSettingsQuery = graphql(`
  query StakeholderSettings($termId: ID!) {
    stakeholderSettings(termId: $termId) {
      stakeholderSettingId
      termId
      name
      respondentType
      scriptTemplateSheetUrl
      contentsTemplateSheetUrl
    }
  }
`);

export const CreateStakeholderSettingMutation = graphql(`
  mutation CreateStakeholderSetting($input: CreateStakeholderSettingInput!) {
    createStakeholderSetting(input: $input) {
      stakeholderSettingId
      name
      respondentType
      scriptTemplateSheetUrl
      contentsTemplateSheetUrl
    }
  }
`);

export const UpdateStakeholderSettingMutation = graphql(`
  mutation UpdateStakeholderSetting($input: UpdateStakeholderSettingInput!) {
    updateStakeholderSetting(input: $input) {
      stakeholderSettingId
      name
      respondentType
      scriptTemplateSheetUrl
      contentsTemplateSheetUrl
    }
  }
`);

export const DeleteStakeholderSettingMutation = graphql(`
  mutation DeleteStakeholderSetting($stakeholderSettingId: ID!) {
    deleteStakeholderSetting(stakeholderSettingId: $stakeholderSettingId)
  }
`);

export const UnregisteredSponsorEmployeeEmailsQuery = graphql(`
  query UnregisteredSponsorEmployeeEmails($termId: ID!, $emails: [String!]!) {
    unregisteredSponsorEmployeeEmails(termId: $termId, emails: $emails)
  }
`);

export const BulkCreateStakeholderRelationsMutation = graphql(`
  mutation BulkCreateStakeholderRelations(
    $input: BulkCreateStakeholderRelationsInput!
  ) {
    bulkCreateStakeholderRelations(input: $input) {
      createdRelationCount
      createdSponsorEmployeeCount
      createdRecipientCount
      createdRespondentCount
      createdSheetCount
      failedSheetCount
      sheetErrorMessage
    }
  }
`);

export const StakeholderRelationsQuery = graphql(`
  query StakeholderRelations($termId: ID!) {
    stakeholderRelations(termId: $termId) {
      stakeholderRelationId
      stakeholderSettingId
      stakeholderSettingName
      respondentName
      respondentEmail
      recipientName
      recipientEmail
      hasAnswer
    }
  }
`);

export const DeleteStakeholderRelationMutation = graphql(`
  mutation DeleteStakeholderRelation($stakeholderRelationId: ID!) {
    deleteStakeholderRelation(stakeholderRelationId: $stakeholderRelationId)
  }
`);

export const StakeholderRespondentsQuery = graphql(`
  query StakeholderRespondents($termId: ID!) {
    stakeholderRespondents(termId: $termId) {
      candidateId
      respondentName
      respondentEmail
      recipientNames
      status
      requestedAt
      interviewId
      interviewStartTime
      interviewerName
      scheduleUrl
    }
  }
`);

export const BulkSendUnbookedManualReminderMutation = graphql(`
  mutation BulkSendUnbookedManualReminder($termId: ID!) {
    bulkSendUnbookedManualReminder(termId: $termId) {
      total
      successCount
      failureCount
      results {
        candidateId
        email
        success
        errorMessage
      }
    }
  }
`);
